import { render, staticRenderFns } from "./indexBrandMuseum.vue?vue&type=template&id=a5f18670&scoped=true&"
import script from "./indexBrandMuseum.vue?vue&type=script&lang=js&"
export * from "./indexBrandMuseum.vue?vue&type=script&lang=js&"
import style0 from "./indexBrandMuseum.vue?vue&type=style&index=0&id=a5f18670&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f18670",
  null
  
)

export default component.exports